<template>
  <div class="wechat-login" :class="{ disabled: reloadTimeout }" v-loading="!wechatImg" @click="getLoginImg">
    <div class="flex-row-center">
      <img v-if="wechatImg" :src="wechatImg" />
      <img v-else :src="`../../../assets/img/unImg.png`" />
    </div>
  </div>
</template>

<script>
import CryptoJS from 'crypto-js/index';
import userApi from "@/assets/js/userApi";
import apiAxios from "@/config/apiAxios";
export default {
  name: "wechat-login",
  data() {
    return {
      sceneId: false,    //每次生成的二维码唯一编码，用于获取扫码状态
      wechatImg: false,    //二维码URL
      expire: -1,
      loginTimeout: false,
      reloadTimeout: false,
    }
  },
  methods: {
    /**
     * 获取当前用户信息
     */
    getCurUserInfo() {
      return userApi.getCurUsrInfo();
    },

    /**
     * 获取登录二维码
     */
    getLoginImg() {
      if (this.loginTimeout)
        window.clearTimeout(this.loginTimeout);
      this.wechatImg = false;
      this.reloadTimeout = false;
      userApi.getWxLoginImg().then(res => {
        if (res.code == 200) {
          let data = JSON.parse(res.data);
         // this.wechatImg = data.qrcodeUrl;
         this.wechatImg="data:image/jpg;base64,"+data.qrcodeUrl;
          this.sceneId = data.sceneId;
          this.expire = Math.floor(new Date().getTime() / 1000) + (data?.expireSeconds || 120);
          this.getLoginStatus();
          window.setTimeout(() => {
            this.reloadTimeout = true;
          }, 60000)
        }
      })
    },

    /**
     * 获取扫码结果
     * https://dcloud.genesysinfo.net/sso-center/test/wechatPub/checkUserScan?sceneId=
     */
    getLoginStatus() {
      if (this.expire <= Math.floor(new Date().getTime() / 1000)) {
        this.getLoginImg();
      } else {
        userApi.checkUserScan(this.sceneId).then(_loginInfo => {
          let _urlSearch = _loginInfo.redirectUrl;

          userApi.doLogin(_urlSearch).then(_data => {
            let _redir = "";
            this.onLoginSuccess(_data, _redir);
          }).catch(_r => {
            this.$emit("isLogin", false);
          })
        }).catch(() => {
          this.loginTimeout = window.setTimeout(() => {
            this.getLoginStatus(this.sceneId)
          }, 3000);
        })
      }
    },

    getCompanyInfo() {
      let _userInfo = JSON.parse(sessionStorage.getItem("USER_INFO"));
      let companys = _userInfo.companys || [];
      if (companys.length > 0) {
        let compamy=companys[0].name;
        let seccode=companys[0].secCode;
        let url = `${config.serverUrl}/apm/v1/ability/DA000030?name=${compamy}`
        apiAxios.get(url, {}, _r => {
          if (_r.code == 200) {
            if (_r.data.eid) {
              let eid = _r.data.eid;
              let companyInfo = JSON.stringify({ eid: eid, fullName: compamy, seccode: seccode });
              sessionStorage.setItem("COMPANY_INFO", companyInfo);
              localStorage.setItem("COMPANY_INFO", companyInfo);
            }
          }
        })
      }
    },

    /**
     * 登录成功
     */
    onLoginSuccess(path) {
      this.getCompanyInfo();
      this.$emit("isLogin", true, path);
      // this.getCurUserInfo().then( userInfo => {
      //   this.getCompanyInfo();
      //   this.$emit( "isLogin", true, path );
      // } )
    }
  },
  mounted() {
    if (this.loginTimeout) {
      window.clearTimeout(this.loginTimeout);
      this.loginTimeout = false;
    }
    if (this.reloadTimeout) {
      window.clearTimeout(this.reloadTimeout);
      this.reloadTimeout = false;
    }

    if (this.$route.query?.code) {
      let _code = this.$route.query?.code;
      let _p = CryptoJS.enc.Base64.parse(this.$route.query?.p).toString(CryptoJS.enc.Utf8);
      let _subscribe = this.$route.query?.subscribe == "1" ? true : false;

      /*未关注用户处理*/
      if (!_subscribe) {
        this.showFollow = true;
        return;
      }

      /*用户登录*/
      try {
        /*获取登录信息*/
        let _loginInfo = JSON.parse(CryptoJS.enc.Base64.parse(_code).toString(CryptoJS.enc.Utf8));
        userApi.doLogin(_loginInfo).then(_data => {
          this.onLoginSuccess(_p);
        }).catch(_r => {
          this.$notify({ type: 'warning', message: '登录失败' });
          this.showLogin = true;
        })
      } catch (e) {
        console.error('wx-login faild')
      }
    } else
      this.getLoginImg();
  },
  beforeDestroy() {
    if (this.loginTimeout) {
      window.clearTimeout(this.loginTimeout);
      this.loginTimeout = false;
    }
    if (this.reloadTimeout) {
      window.clearTimeout(this.reloadTimeout);
      this.reloadTimeout = false;
    }
  }
}
</script>

<style lang="less" scoped>
.wechat-login {
  width: 100%;
  text-align: center;
  position: relative;

  &.disabled {
    &:before {
      cursor: pointer;
      position: absolute;
      content: "二维码失效，点击刷新";
      width: 100%;
      height: calc(100% - 100px);
      background: url('~@/assets/img/qrcode-fresh.png') no-repeat center;
      background-color: rgba(255, 255, 255, 0.8);
      font-size: 16px;
      color: #000000;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      padding-top: 100px;
    }
  }

  img {
    width: 360px;
    height: 360px;
  }
}
</style>
